<template>
  <div class="mainContainer" :style="loginImage">
    <TopHeader :pageTitle="pageHead" />
    <!----------------Main Page------------------------------------------>
    <div class="pageContainer shadow-lg rounded" fluid="sm">
      <div class="page-content">
        <SecondaryHeader1 />
        <!------------Content Area-------------->
        <div class="contentWrapper pageWrapper shadow-lg mb-3 rounded">
          <!-----------Registration Form---------------->
          <b-form
            novalidate
            @submit.prevent="validateBeforeSubmit"
            v-if="show"
            class="mt-5 justify-content-center formElem"
          >
            <!-- Password fields -->
            <b-form-group id="input-group-password">
              <label label-for="password" class="col-md-3">Password:</label>
              <b-form-input
                id="password"
                v-model="form.password"
                type="password"
                v-validate="'required'"
                class="input col-md-3"
                :class="{ 'is-danger': errors.has('password') }"
                autocomplete="off"
              ></b-form-input>
              <div class="infoDiv ml-1">
                <i
                  class="fas fa-info-circle"
                  title="Your password can't be similar to your username. Your password must be between 8-15 characters. Your password must contain at least one uppercase letter,one lowercase letter, one number and one special character."
                ></i>
              </div>
              <small
                v-if="errors.has('password')"
                class="field-text is-danger col-md-3"
                >{{ errors.first("password") }}</small
              >
            </b-form-group>

            <b-form-group id="input-group-password_repeat">
              <label label-for="password_repeat" class="col-md-3"
                >Confirm Password:</label
              >
              <b-form-input
                id="password_repeat"
                v-model="form.password_repeat"
                type="password"
                v-validate="'required'"
                class="input col-md-3"
                :class="{ 'is-danger': errors.has('password_repeat') }"
                autocomplete="off"
              ></b-form-input>
              <small
                v-if="errors.has('password_repeat')"
                class="field-text is-danger col-md-3"
                >{{ errors.first("password_repeat") }}</small
              >
            </b-form-group>

            <b-button
              type="submit"
              variant="primary"
              class="mt-5 mr-2 submitBtn"
              align="center"
              >Submit</b-button
            >
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeader from "@/components/BaseFiles/TopHeader.vue";
import SecondaryHeader1 from "@/components/BaseFiles/SecondHeader1.vue";
// Import Images
import bgImage from "@/assets/img/dbTiles/BG.png";

export default {
  name: "UserRegistration",
  components: {
    TopHeader: TopHeader,
    SecondaryHeader1: SecondaryHeader1
  },
  data() {
    return {
      form: {
        password: "",
        password_repeat: ""
      },

      show: true,
      loginImage: {
        backgroundImage: "url(" + bgImage + ")"
      },
      pageHead: "User Settings"
    };
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validate().then(result => {
        if (result) {
          // eslint-disable-next-line
          alert("Form Submitted!");
          return;
        }

        alert("Correct the errors!");
      });
    }
  }
};
</script>
<style lang="scss">
.formElem {
  left: 20%;
  position: relative;
}

label,
input {
  position: relative;
  display: inline-block;
  margin-right: 2%;
  font-weight: 600;
  font-size: 13px;
}
.form-control {
  display: inline-block !important;
  font-size: 13px;
  font-weight: normal;
}

.pageWrapper {
  margin: 1rem 8rem 1rem 8rem;
  padding: 5rem;
}
.submitBtn {
  position: relative;
  left: 20%;
}
.contentWrapper {
  background: $color-white;
  position: relative;
  margin: 1rem 5rem;
  height: 84%;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>